import React, { Fragment, useState, useEffect, useRef, forwardRef, useCallback } from 'react';
import { GetNotifcations, AddNotifcation, RemoveNotifcation, GetNotifcationFields } from "../../REST/utilities";
import { GetList, GetById, AddItem, UpdateItem, DeleteItem } from '../../REST/crud'

import { useForm, Controller, useFormState } from "react-hook-form";
import TextField from '@mui/material/TextField';
import NativeSelect from '@mui/material/NativeSelect';
import AddIcon from '@mui/icons-material/Add'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import TemplateEditor from "../../Utils/templates";
import { GetSystemSettings  } from '../../REST/utilities';
import DefaultSettings from '../../Utils/settings';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CodeIcon from '@mui/icons-material/Code';
import PreviewIcon from '@mui/icons-material/Preview';
import DescriptionIcon from '@mui/icons-material/Description';
import Button from '@mui/material/Button';
import DOMPurify from 'dompurify';

import {
    DataGrid, GridToolbarContainer,
    GridToolbarExport,
    gridClasses,
} from '@mui/x-data-grid';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';
function CustomToolbar() {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>

        </GridToolbarContainer>
    );
}
export default function Notifications() {
     
    const [viewstate,setViewstate] = useState({fields:[]})  
    const {fields} = viewstate
    const [mode,setMode] = useState(null)
    const [refreshKey, setRefreshKey] = useState(0)
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            const fieldsResult = await GetNotifcationFields()
            setViewstate({fields: fieldsResult?.data})
        })()
    }, [])
    
    const fetchNotifications = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetList('Notifications', params);

        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            return {
                data: result.data,
                pagination: { total: result.data.length, page: 1, totalPages: 1 }
            };
        }

        return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
    }, []);
    
    const handleMode = (mode)=>{  setMode(mode)  }

    const handleRowClick = async (row) => {
        const result = await GetById('Notifications', row._id)
        setMode(result.data)
    }

    const handleData = (data) => {
        if(!data._id)
        {
            AddItem('Notifications',data).then(() => {
                setMode(null)
                setRefreshKey(k => k + 1)
                DefaultSettings.showAlert('Notification event saved successfully.', 'success')
            }).catch(() => {
                DefaultSettings.showAlert('Failed to save notification event.', 'error')
            })
        }
        else 
        {
            UpdateItem('Notifications',data._id,data).then(() => {
                setMode(null)
                setRefreshKey(k => k + 1)
                DefaultSettings.showAlert('Notification event updated successfully.', 'success')
            }).catch(() => {
                DefaultSettings.showAlert('Failed to update notification event.', 'error')
            })
        }
    }

    const handleDelete = (id) => {
        DeleteItem('Notifications',id).then(() => {
            setRefreshKey(k => k + 1)
            DefaultSettings.showAlert('Notification event deleted.', 'success')
        }).catch(() => {
            DefaultSettings.showAlert('Failed to delete notification event.', 'error')
        })
    }
    const getColumns = ()=>{
        const actions = {
            field: 'actions', headerName: 'Actions', flex: 0.5, minVisible: 'xs', renderCell: (params) => {
                return <IconButton onClick={(e) => { e.stopPropagation(); handleDelete(params.row._id) }}><DeleteIcon /></IconButton>
            }
        }
        let cols =  [
            { 
                field: 'name', headerName: 'Event Name', flex: 0.5 ,  id: 'notification_1', minVisible: 'xs' 
            },
            {
                field: 'module', headerName: 'Module', flex: 0.5,  id: 'notification_2', type: 'singleSelect', valueOptions: ['Invoices', 'Waitlist', 'Company', 'Accounts', 'Messages', 'Insurance', 'Agreements', 'Workorderdata', 'Inspectiondata', 'Assetdata', 'Landing', 'Tiedown'], minVisible: 'sm'
            },
            {
                field: 'trigger', headerName: 'Event Trigger', flex: 0.5 ,  id: 'notification_3', type: 'singleSelect', valueOptions: ['Created', 'Updated', 'Removed', 'Scheduled'], minVisible: 'md'
            } 
        ]
        cols.push(actions)
        return cols;
    } 
     
   return  ( 
    <PageShell>
        <PageHeader
            title="Notifications"
            back
            onBack={() => navigate(-1)}
            actions={
                <Action
                    primary
                    icon={<AddIcon />}
                    label="Add Event"
                    onClick={() => { handleMode({}) }}
                />
            }
        />

        {mode !== null && <FormDialog key={mode?._id || 'new'} open={mode !== null} data={mode} handleClose={() => handleMode(null)} fields={fields} handleSave={handleData} />  }

        <PageContent fill>
            <ResponsiveDataGrid
                key={refreshKey}
                columns={getColumns()}
                fetchData={fetchNotifications}
                initialPageSize={10}
                pageSizeOptions={[10, 25, 50, 100]}
                getRowId={(i) => i?._id}
                onRowClick={handleRowClick}
            />
        </PageContent>
    </PageShell>
    )
}



function FormDialog({ open = false, data, handleClose, handleSave, fields = [] }) {
      const [moduleFields,setModuleFields] = React.useState({})
      const [templateMode, setTemplateMode] = React.useState(null) // null | 'template' | 'html'
      const [htmlTab, setHtmlTab] = React.useState(0) // 0=Code, 1=Preview
       
        React.useEffect(()=>{
            GetSystemSettings().then((result)=>{
                const setting = result.data.find((x)=>{ return x.name == "appconfig"} )
                if(setting && setting.jsonvalue && setting.jsonvalue.changenotify) {
                    setModuleFields(setting.jsonvalue.changenotify)
                }
            }).catch((err) => {
                console.log('Failed to load system settings for changenotify:', err);
            })
        },[])
    

    const schema = yup.object({
        name: yup.string().trim().required(),
        module: yup.string().trim().required(),
        trigger: yup.string().trim().required(),
        template: yup.string().trim().required(),
        notify: yup.string().trim().required(),
        changefield : yup.string(),
        changevaluefrom : yup.string(),
        changevalueto : yup.string(),
        customCode : yup.string(),
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset, getValues,watch } = useForm({
        defaultValues: {
            name: '',
            module: '',
            trigger: '',
            template: '',
            notify: '',
            changefield:"",
            changevaluefrom:"",
            changevalueto:"",
            customCode:""
        },
        resolver: yupResolver(schema)
    });

    const trigger = watch("trigger")
    const module = watch("module")
    const changefield= watch("changefield")
    const changevaluefrom = watch("changevaluefrom")
    const changevalueto = watch("changevalueto")

   
    
    // Wait until data is ready before resetting form
    useEffect(() => {
        clearErrors()
        reset(data)
        // Restore templateMode from saved templateType, or auto-detect from template content
        if (data && data.templateType) {
            setTemplateMode(data.templateType === 'HTML' ? 'html' : 'template')
        } else if (data && data.template) {
            const isHtml = /<[a-z][\s\S]*>/i.test(data.template)
            setTemplateMode(isHtml ? 'html' : 'template')
        } else {
            setTemplateMode(null)
        }
        setHtmlTab(0)
    }, [open, data, clearErrors, reset])

    const onSubmit = (formData) => {
        handleSave({ ...formData, templateType: templateMode === 'html' ? 'HTML' : 'Visual' })
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    const getOptions = (type) => {
        if (type === 'Modules') {
            // Static list of all available modules
            const allModules = [
                'Invoices', 'Waitlist', 'Company', 'Accounts', 'Messages', 
                'Insurance', 'Agreements', 'Inspectiondata', 'Workorderdata', 
                'Assetdata', 'Landing', 'Tiedown', 'IncidentReports'
            ];
            return (
                <Fragment>
                <option></option>
                {
                    allModules.map((e,idx) => <option key={idx}>{e}</option>)
                }
                </Fragment>
            )  
        }
        else if (type === 'Trigger') {
            return <Fragment>
                <option></option>
                <option>Created</option>
                <option>Updated</option>
                <option>Removed</option>
                <option>Scheduled</option>
            </Fragment>
        }
        else if (type === 'Notify') {
            return <Fragment>
                <option></option>
                <option>Internal</option>
                <option>External</option>
                <option>Both</option>
            </Fragment>
        }
        return <option>NA</option>
    }

    return (
    <WorkflowDialogShell
        open={open}
        onClose={handleClose}
        onSave={handleSubmit(onSubmit)}
        title="Event Details"
    >
        <div className='container-fluid'> 
            <div className='row'>
                <div className='col-lg-6 col-md-8 col-sm-12'>
                    <Controller name="name" control={control} 
                        render={({ field }) => 
                            <TextField margin='dense' error={isError(errors.name)} variant='standard'
                            helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-6 col-md-8 col-sm-12'>
                    <Controller name="module" control={control} 
                        render={({ field }) => 
                            <FormControl error={isError(errors.module)} variant='standard' margin='dense' fullWidth>
                                    <InputLabel>Module</InputLabel>
                                    <NativeSelect {...field}>{getOptions('Modules')}</NativeSelect>
                                    {errors.module && <FormHelperText>{errors.module.message}</FormHelperText>}
                            </FormControl>} />
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-6 col-md-8 col-sm-12'>
                    <Controller name="trigger" control={control} 
                        render={({ field }) => 
                            <FormControl error={isError(errors.trigger)} variant='standard' margin='dense' fullWidth>
                                <InputLabel shrink >Trigger Type</InputLabel>
                                <NativeSelect {...field}>{getOptions('Trigger')}</NativeSelect>
                                {errors.trigger && <FormHelperText>{errors.trigger.message}</FormHelperText>}
                            </FormControl>} />
                </div>
            </div>
            {
                trigger != "" && trigger == "Updated" && module != "" && moduleFields[module] &&
                 
                (
                <div className='row'>
                    <div className='col-lg-6 col-md-8 col-sm-12'>
                    <Controller name="changefield" control={control} 
                        render={({ field }) => 
                            <FormControl error={isError(errors.changefield)} variant='standard' margin='dense' fullWidth>
                                <InputLabel shrink >Change Field</InputLabel>
                                <NativeSelect {...field}>
                                    <option> </option>
                                    <option>All Fields</option>
                                    { moduleFields[module].map((x,idx)=>{   
                                           return (<option key={idx} value={x.name} >{x.label}</option>) 
                                       } ) 
                                }</NativeSelect>
                                {errors.changefield && <FormHelperText>{errors.changefield.message}</FormHelperText>}
                            </FormControl>} />
                    
             
                    </div>
                </div>
               )
                
            }
            {  trigger != "" && trigger == "Updated" && module != "" && moduleFields[module] && 
                typeof changefield != "undefined" && changefield != "All Fields" && changefield != "" &&
                moduleFields[module].find((x)=>{ return x.name == changefield }).values &&
                (    
                    <div className='row'>
                        <div className='col-lg-6 col-md-8 col-sm-12'>
                            <Controller name="changevaluefrom" control={control} 
                            render={({ field }) => 
                                <FormControl error={isError(errors.changevaluefrom)} variant='standard' margin='dense' fullWidth>
                                    <InputLabel shrink >Value From</InputLabel>
                                    <NativeSelect {...field}>
                                        <option></option>
                                        { moduleFields[module].find((x)=>{ return x.name == changefield })
                                            .values
                                            .filter((x)=>{ return !changevalueto || x != changevalueto  })
                                            .map((x,idx)=>{   
                                                return (<option key={idx} >{x}</option>) 
                                                } 
                                            ) 
                                        }
                                    </NativeSelect>
                                    {errors.changevaluefrom && <FormHelperText>{errors.changevaluefrom.message}</FormHelperText>}
                                </FormControl>} />
                            <Controller name="changevalueto" control={control} 
                            render={({ field }) => 
                                <FormControl error={isError(errors.changevalueto)} variant='standard' margin='dense' fullWidth>
                                    <InputLabel shrink >Value To</InputLabel>
                                    <NativeSelect {...field}>
                                        <option></option>
                                        { moduleFields[module].find((x)=>{ return x.name == changefield })
                                            .values
                                            .filter((x)=>{ return !changevaluefrom || x != changevaluefrom  })
                                            .map((x,idx)=>{   
                                                return (<option key={idx} >{x}</option>) 
                                                } 
                                            ) 
                                        }
                                    </NativeSelect>
                                    {errors.changevalueto && <FormHelperText>{errors.changevalueto.message}</FormHelperText>}
                                </FormControl>} />  
                        </div>
                    </div>
                )
            } 
            <div className='row'>
                <div className='col-lg-6 col-md-8 col-sm-12'>
                    <Controller name="notify" control={control} 
                        render={({ field }) => 
                            <FormControl error={isError(errors.notify)} variant='standard' margin='dense' fullWidth>
                                <InputLabel shrink >Notification Type</InputLabel>
                                <NativeSelect {...field}>{getOptions('Notify')}</NativeSelect>
                                {errors.notify && <FormHelperText>{errors.notify.message}</FormHelperText>}
                            </FormControl>} />
                </div>
            </div>
            {module && trigger && (
            <div className='row'>
                <div className='col-lg-6 col-md-8 col-sm-12'>
                    <FormControl variant='standard' margin='dense' fullWidth>
                        <InputLabel shrink>Editor Type</InputLabel>
                        <NativeSelect
                            value={templateMode || ''}
                            onChange={(e) => setTemplateMode(e.target.value || null)}
                        >
                            <option value=''></option>
                            <option value='template'>Visual Editor</option>
                            <option value='html'>HTML Code Editor</option>
                        </NativeSelect>
                    </FormControl>
                </div>
            </div>)}
            {module && trigger && (
            <div className='row' style={{ marginTop: 16 }}>
                <div className='col-12'>

                    <Controller name='template' control={control}
                        render={({ field }) => (
                            <FormControl required error={isError(errors['template'])} variant='standard' fullWidth>

                                {/* Nothing shown until user picks an option */}
                                {templateMode === null && (
                                    <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mt: 1 }}>
                                        Select an editor type above to add a template.
                                    </Typography>
                                )}

                                {templateMode === 'template' && (
                                    <Box sx={{ mb: 1 }}>
                                        <TemplateEditor settings={fields} module={module} field={field} />
                                    </Box>
                                )}

                                {templateMode === 'html' && (
                                    <Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
                                            <Button
                                                variant='contained'
                                                size='small'
                                                startIcon={<DescriptionIcon />}
                                                onClick={() => window.open('https://test.revjet360.com/', '_blank')}
                                                sx={{ backgroundColor: '#7c3aed', '&:hover': { backgroundColor: '#6d28d9' } }}
                                            >
                                                Open Document Converter
                                            </Button>
                                        </Box>
                                        <Tabs value={htmlTab} onChange={(_, v) => setHtmlTab(v)} sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}>
                                            <Tab icon={<CodeIcon />} iconPosition='start' label='HTML Code' />
                                            <Tab icon={<PreviewIcon />} iconPosition='start' label='Preview' />
                                        </Tabs>
                                        {htmlTab === 0 && (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                multiline
                                                rows={14}
                                                variant='outlined'
                                                placeholder='<html>...<body>...</body></html>'
                                                error={isError(errors['template'])}
                                                sx={{
                                                    '& textarea': {
                                                        fontFamily: 'Consolas, Monaco, "Courier New", monospace',
                                                        fontSize: '13px',
                                                        lineHeight: '1.6'
                                                    }
                                                }}
                                            />
                                        )}
                                        {htmlTab === 1 && (
                                            <Box sx={{
                                                border: '2px solid #e0e0e0',
                                                borderRadius: 2,
                                                p: 3,
                                                minHeight: 350,
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                overflow: 'auto'
                                            }}>
                                                <Typography variant='caption' sx={{ display: 'block', mb: 2, color: '#666', fontStyle: 'italic' }}>
                                                    Preview (as the recipient will see it)
                                                </Typography>
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(field.value || '') }} />
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {errors['template'] && <FormHelperText>{errors['template'].message}</FormHelperText>}
                            </FormControl>
                        )}
                    />
                </div>
            </div>
            )}

            <div className='row' style={{ marginTop: 16 }}>
                <div className='col-12'>
                    <div style={{ marginBottom: 4, fontSize: 12, color: '#555', fontWeight: 600 }}>
                        Custom Condition (optional)
                    </div>
                    <div style={{ marginBottom: 6, fontSize: 11, color: '#888', lineHeight: 1.5 }}>
                        JavaScript that must return <code>true</code> to fire this notification.
                        Available: <code>entity</code> (the record), <code>changes</code> (Updated trigger: <code>&#123; field: &#123; from, to &#125; &#125;</code>).<br />
                        Examples:&nbsp;
                        <code>entity.aircraftType === 'Single Jet'</code>&nbsp;&nbsp;
                        <code>entity.amount &gt; 5000</code>&nbsp;&nbsp;
                        <code>changes.status?.to === 'Active'</code><br />
                        Scheduled:&nbsp;
                        <code>new Date() - new Date(entity.endDate) &gt; 30 * 86400000</code>
                    </div>
                    <Controller name="customCode" control={control}
                        render={({ field }) =>
                            <TextField
                                {...field}
                                multiline
                                minRows={3}
                                maxRows={8}
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder={'// Return true to fire, false to skip\nentity.aircraftType === \'Single Jet\''}
                                inputProps={{ style: { fontFamily: 'monospace', fontSize: 12 } }}
                                error={isError(errors.customCode)}
                                helperText={errors.customCode?.message}
                            />
                        }
                    />
                </div>
            </div>
        </div>
    </WorkflowDialogShell>
    )
}
 
